import React,{useState,useEffect} from "react";
import { Link} from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import {loginschema} from './validation'; 
import {InputAdornment }  from '@material-ui/core';
import {Email,Lock} from '@material-ui/icons';
import { userActions } from '_actions/user.actions';
import { LocalStorageService } from '_services';
import { connect } from 'react-redux';
import { Spinner } from '../../Hoc/Spinner'
import {FormInput,FormButton, FormCheckBox} from "_components/FormElements/FormInput";
import {UncontrolledAlert , Button} from "reactstrap";
//import { Multiselect } from 'multiselect-react-dropdown';
//import Select from "react-select";
import logo from 'assets/img/brand/ch-logo.svg'
import axios from 'axios';

import { PhoneInput2, OtpInput } from "_components/FormElements/FormInput";
import { Col, Row } from "reactstrap";
//import parsePhoneNumber from 'libphonenumber-js';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import { history } from '../../../_helpers';
import { userService } from "_services";

const Login = props => {  

  
  const [apptoken, setApptoken] = useState("");
  const [invalidAuth, setInvalidAuth] = useState(false)
  const [loading, setLoading] = useState(false)
  const [slogin, setSlogin] = useState(true)
  const [s2fa, setS2FA] = useState(false)
  const [invalidOtp, setInvalidOtp] = useState(false)
  
 // const { loggingIn } = props;  
 
    //-----
    let countryCode = '';
  //  const { handleChangeSelect, signUp } = props;
   
   // const { country, countryId, email, firstName, lastName } = props.values;
   // props.values.mobile = props?.values?.mobile[0] ? props.values.mobile : props.values.switchPhone
  //  const mobile = props?.values?.mobile[0] ? props.values.mobile : props.values.switchPhone
  //  const { countryList } = props.staticValues;
    const [invalidNumber , setInvalidNumber] = useState(false)
    const [isPhone, setIsPhone] = useState(0);
    const [otp, setOtp] = useState(0);
    const [phone, setPhone] = useState(false);
    const [emailid, setEmail] = useState(false);
    let [verifyMethod, setVerifyMethod] = useState(1);
    
    const [mobile, setMobile] = useState();
    const [emails, setEmails] = useState(null);
    const [userdata, setUserdata] = useState(null);
    
    //-----
  
  const { register, handleSubmit, control, errors } = useForm({
//    mode:'onBlur',
    resolver: yupResolver(loginschema)
  });
  const onSubmit = data => {    
     if (data) {
      
         setUserdata(data)   
         userService.loginValidation(data.email,data.password,apptoken).then(res => { 
             console.log(' validation data : ', res);
           if(res) {  
                setInvalidAuth(false)      
              
                setMobile(res.phone)
                setEmails(res.email)

                setLoading(true)
                setSlogin(false)
                setS2FA(true)
              //  handlePhone()

              
           } else {
              setInvalidAuth(true)
           }
         },
         error => {  console.log(' validation error : ', error );  setInvalidAuth(true)   }); 
     }
  }

  const errorCallback = error => {
    setLoading(false)
    setInvalidAuth(true)
  };

  const successCallback = success => {
    setLoading(false)
  };
  
  
    useEffect( () => {
        //console.log("props:",props);
        const localStorageService = LocalStorageService.getService();
        axios.post('/app', { 
            clientKey:"clientAppFE",      
            secretKey:"!$Ch@nnelHub#*&"         
            }).then(res =>{
              localStorageService.setAppToken(res.data.Authorization);
                setApptoken(res.data.Authorization);
            });
    }, []);  
  
    //-----
    const reset = () => {
        setIsPhone(0);
        handleChangeSelect('verified', 0);
    }
const handlePhone = async () => {

    

        
            axios.post('/mailerservice/Email_Otp_Verification', {
                email: emails,
                companyName: "Admin", //companyName?.length ? companyName[0].name : '',
            }).then(res => {
                setOtp(res.data);
                setIsPhone(1);
            });
        

        setTimeout(() => {
            setOtp('$$$$$$');
        }, verifyMethod == 1 ? 100000 : 300000)


          // console.log('dynamic data : ', userdata)
          // 
    }

    // const validatePhoneNumber = function(phoneNumber) {
    //     try {
    //         const parsedNumber = parsePhoneNumber(phoneNumber, null, {
    //           v2: true, 
    //         });
        
    //         // Check if it's a valid number
    //         if (parsedNumber.isValid()) {
    //           return true;
    //         } else {
    //           return false;
    //         }
    //       } catch (error) {
    //         return false;
    //       }
    //   }

    const reSendOTP = () => {
        setOtp('$$$$$$');
        handlePhone();
        handleChangeSelect('verified', 0);
    }

    const matchOTP = (param) => {

        console.log("param:", param);
        console.log("settops:", otp);
        if (param == otp) {
           // signUp(true);
            console.log("enable finish");
            setInvalidOtp(false)
            props.login(userdata.email,userdata.password,apptoken,successCallback,errorCallback);
        }
        else 
        {
            setInvalidOtp(true);        
        }
    }

    const handleChangeVerificationMethod = (type) => {
        verifyMethod = type;
        setVerifyMethod(type);
        // handleChangeSelect('verificationMethod', type);
        reset();
        reSendOTP();

    }

    const handleEmailToggle = () => {
            setVerifyMethod(0)
            if(phone)
              setPhone(false)
            setEmail(!emailid)        
    }

    const handlePhoneToggle = () => {
        setVerifyMethod(1)
        if(emailid)
          setEmail(false)

        setPhone(!phone)
    }

    const handleSubmit1 = () => {

    }
     const onSubmit1 = () => {
      
    }
    const handleChangeSelect = () => {

    }
      const labelButtonStyle = {
        backgroundColor: '#2c9db7',
        color: 'white',
        padding: '8px 16px', 
        borderRadius: '4px', 
        cursor: 'pointer', 
      };
    //------
  return (
     
    <div class="main-content">      
      <div className="head-logo mt-2 mb-2">
        <img  onError={(event)=>{axios.post('/media/errorLog', {url:event.target.src, documentTypeId:1, name:null}); event.target.setAttribute("src",process.env.REACT_APP_DEFALTIMAGE+"document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg");}}  src={logo}/>
        </div>
    <div class="header signup-header-bg loginpad">
      <div class="container">
        <div class="header-body text-center mb-4">
          <div class="row justify-content-center">
            <div class="col-xl-10 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Welcome!</h1>
              <p class="text-lead text-white">ChannelHub is the game changer for consumer tech channels. We help retailers and distributors find new products and qualified vendors from around the globe</p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>

    <div class="container loginmargin  pb-5">
    <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
    <div class="card bg-secondary border-0 mb-0">  
  
    {slogin &&  <div class="card-body px-lg-5 py-lg-5">   
    <form onSubmit={handleSubmit(onSubmit)}>
                <div class="form-group mb-3" >
                  <div class="input-group input-group-merge input-group-alternative">                    
                    <FormInput 
        id="email"
        type="email"
        name="email"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Email />
            </InputAdornment>
          ),
        }}
        placeholder="Email Id"      
        register={register}
        error={errors.email}
        />
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group input-group-merge input-group-alternative">                   
                    <FormInput 
      id="password"
      type="password"
      name="password"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Lock />
          </InputAdornment>
        ),
      }}
      placeholder="Password"
      register={register}
      error={errors.password}
      />
                  </div>
                </div>
               
                    {/* <span className="alert-icon">
                      <i className="ni ni-like-2" />
                    </span>
                    <span className="alert-text ml-1">
                      <strong>Warning!</strong> This is a warning alert—check it
                      out!
                    </span> */}
                    {invalidAuth && <p style={{ color: "red", textAlign: "center", fontSize: '.9rem', fontWeight: 600, marginTop: '-1rem' }}>!Please check your email and password</p>}
              

                {/* <FormCheckBox 
                id="customCheckLogin"
                type="checkbox"
                label="Remember me"
                register={register}
                /> */}
                {/* <a className="forgot" href="dev-fo.channelhub.tech">Forgot Password</a> */}
                {/* <Row className=""> */}
                {loading ? <Spinner />:''}
                  <FormButton
                  className="btn-sin btn btn-primary"
      id="loginbutton"
      name="loginbutton"
      value="Sign in" 
      />
                

              </form>   
              </div> } 
              {s2fa && <div className="container Fullotp" style={{padding:'0'}}>
                <form noValidate onSubmit={handleSubmit1(onSubmit1)}>
                    <div className="row">

                        {isPhone == 0 ? (
                            <div className="otp_get justify-content-md-center w-100" >
                                <Col lg="12" className="wek-cent">
                                    <div className="form-group otpphone mt-5">
                                    <h5 className='mob-signhead' style={{display:'none'}}>verification Code</h5>

                                        <p style={{ color: "#777879", textAlign: "center", fontSize: '1.2rem', fontWeight: 600, marginTop: '-1rem' }}>Two-Factor Authentication Code</p>
                                        <p>
                                        Any time you login we are asking auth code for extra security reason, 
                                        </p>
                                        {/* <FormControlLabel control={
                                                <Checkbox name={"Email"} label={"Email"} checked={emailid} onChange={handleEmailToggle} /> 
                                            } 
                                            label='Send Email to registered Email Id' 
                                                style={{ color: 'black' }}

                                            /> */}
                                        {/* <FormControlLabel control={
                                                <Checkbox name={"Phone"} label={"Phone"} checked={phone}  onChange={handlePhoneToggle}/> 
                                            } 
                                            label='Send text message to registered email Id'  
                                            style={{ color: 'black' }}
                                            /> */}
                                            <div>
                                           
                                            </div>
                                   

                                    
                                    </div>
                                       <button
                                        type="button"
                                        className={`btn btn-primary ${
                                            !phone && !emailid ? "hidden" : ""
                                        }`}
                                           onClick={handlePhone}
                                           >
                                       Send Code to registered Email Id
                                       </button>
                                </Col>
                            </div>

                        ) : (
                            <div  >
                                <div className="verify-box">
                                    <h3>Enter Code</h3>
                                    {/* {verifyMethod == 1 ?
                                        <>
                                            <span>We have sent you SMS with 6 digit verification code on</span>
                                            <p>{mobile[1]}</p>
                                        </> :
                                        <>
                                            <span>We have sent you Email with 6 digit verification code on</span>
                                            <p>{emails}</p>
                                        </>
                                    }  */}
                                     <span>We have sent you Email with 6 digit verification code on</span>
                                            <p>{emails}</p>
                                    <OtpInput
                                        matchOTP={matchOTP}
                                        reSendOTP={reSendOTP}
                                        handleChangeSelect={handleChangeSelect}
                                        maxTime={verifyMethod == 1 ? 100 : 300}
                                    />
                                    {invalidOtp && <span style={{color:'red', fontWeight:"bold"}}>Invalid OTP. try again </span>}
                                    {/* {verifyMethod == 1 ?
                                        <>
                                            <p>If you don't receive the verification code by sms, <span style={{ color: "blue", cursor: "pointer" }} onClick={() => handleChangeVerificationMethod(2)}>click here to receive it by email.</span>
                                            </p>
                                        </> :
                                        <>
                                            <p>If you don't receive the verification code by email, <span style={{ color: "blue", cursor: "pointer" }} onClick={() => handleChangeVerificationMethod(1)}>click here to receive it by sms.</span>
                                            </p>
                                        </>
                                    } */}
                                </div>
                            </div>
                        )
                        }
                    </div>
                  </form>
                </div> 
              }
              </div>
              </div>
              </div>
              </div>
       
                
      
              
      </div> 
    
  
  );
}

function mapState(state) {    
    const { loggingIn } =state.authentication;
    return { loggingIn };
}

const actionCreators = {
    login: userActions.login
};

const connectedLoginPage = connect(mapState, actionCreators)(Login);
export { connectedLoginPage as Login };
